import axios from 'axios'

const api = axios.create({
  baseURL: 'https://zipcloud.ibsnet.co.jp/api/',
})
export type AddressInfo = {
  address1: string
  address2: string
  address3: string
  kana1: string
  kana2: string
  kana3: string
  prefcode: string
  zipcode: string
}

const getAddressInfoByZipcode = (
  code: string
): Promise<{ results: AddressInfo[] }> => {
  return api.get(`/search?zipcode=${code}`).then(res => res.data)
}

export { getAddressInfoByZipcode }
